import { Anchor } from "lucide-react";
import { WaveDivider } from "@/components/WaveDivider";

const MENU_FOOD_URL = "https://customer-assets.emergentagent.com/job_seaside-bites-6/artifacts/zuelvo6d_SSB%20FINAL%20MAIN%20MENU.png";
const MENU_DRINKS_URL = "https://customer-assets.emergentagent.com/job_seaside-bites-6/artifacts/aqu6h131_SSB%20FINAL%20SECOND%20MENU.png";
const MENU_SHOP_URL = "https://customer-assets.emergentagent.com/job_seaside-bites-6/artifacts/5e2c42ia_SSB%20SHOP%20FINAL.png";

export default function MenuPage() {
  const menuItems = [
    {
      id: "food",
      title: "Main Menu",
      subtitle: "Burgers, Hot Dogs, Quesadillas, Tacos & More",
      image: MENU_FOOD_URL,
    },
    {
      id: "drinks",
      title: "Kids Menu, Drinks & Treats",
      subtitle: "Kids Meals, Frozen Drinks, Ice Cream & Fresh Fruit",
      image: MENU_DRINKS_URL,
    },
    {
      id: "shop",
      title: "Seaside Shop",
      subtitle: "Merchandise & Beach Essentials",
      image: MENU_SHOP_URL,
    },
  ];

  return (
    <div data-testid="menu-page" className="overflow-hidden">
      {/* Hero Section */}
      <section
        className="relative pt-32 pb-20 md:pt-40 md:pb-28"
        style={{
          background: "linear-gradient(135deg, #E91E8C 0%, #C8147A 50%, #00B4D8 100%)",
        }}
      >
        {/* Decorative */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-24 left-10 opacity-10">
            <Anchor className="w-24 h-24 text-white" />
          </div>
          <div className="absolute bottom-20 right-10 opacity-10">
            <Anchor className="w-32 h-32 text-white" />
          </div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="font-accent text-3xl md:text-4xl text-white/90">
            Check Out Our
          </span>
          <h1 className="font-heading font-bold text-5xl md:text-7xl text-white mt-2 mb-6 text-shadow">
            Menu
          </h1>
          <p className="font-body text-xl text-white/90 max-w-2xl mx-auto">
            Fresh, made-to-order favorites to enjoy on the water.
          </p>
          <p className="font-body text-sm text-white/70 mt-4 max-w-xl mx-auto">
            *Menu items and prices are subject to change without notice. Please inform us of any food allergies before ordering. We are not responsible for allergic reactions.
          </p>
        </div>

        <div className="absolute bottom-0 left-0 right-0">
          <WaveDivider color="#FAF4E1" />
        </div>
      </section>

      {/* Menu Images Section */}
      <section className="bg-seaside-sand py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16 md:space-y-24">
            {menuItems.map((item, index) => (
              <div
                key={item.id}
                data-testid={`menu-item-${item.id}`}
                className={`flex flex-col ${
                  index % 2 === 1 ? "lg:flex-row-reverse" : "lg:flex-row"
                } gap-8 lg:gap-12 items-center`}
              >
                {/* Text */}
                <div className="lg:w-1/3 text-center lg:text-left">
                  <h2 className="font-heading font-bold text-3xl md:text-4xl text-seaside-navy mb-3">
                    {item.title}
                  </h2>
                  <p className="font-body text-lg text-gray-600">
                    {item.subtitle}
                  </p>
                </div>

                {/* Image */}
                <div className="lg:w-2/3">
                  <div className="relative group">
                    <div className="absolute -inset-4 bg-seaside-magenta/20 rounded-3xl transform rotate-1 group-hover:rotate-2 transition-transform duration-300" />
                    <img
                      src={item.image}
                      alt={item.title}
                      data-testid={`menu-image-${item.id}`}
                      className="relative rounded-2xl shadow-2xl w-full max-w-2xl mx-auto transform group-hover:scale-[1.02] transition-transform duration-300"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Note Section */}
      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-seaside-water rounded-3xl p-8 md:p-12">
            <h3 className="font-heading font-bold text-2xl md:text-3xl text-seaside-navy mb-4">
              Find Us On The Water!
            </h3>
            <p className="font-body text-lg text-gray-700 mb-6">
              We service the surrounding islands of Pasco County. Whether you're
              anchored offshore, at the sandbar, or exploring the islands – we'll
              come to you!
            </p>
            <a
              href="tel:727-648-6060"
              data-testid="menu-call-btn"
              className="inline-flex items-center gap-2 px-8 py-4 bg-seaside-magenta text-white font-heading font-bold rounded-full hover:bg-seaside-magenta-hover transition-colors duration-300"
            >
              Call 727-833-9500
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
